export enum UserDealStatus {
  PENDING = 'PENDING',

  APPROVED = 'APPROVED',

  REJECTED = 'REJECTED',

  COMPLETED = 'COMPLETED',
}
